// Module
var code = `<div class="ng-scope" ng-class="{
  'input-append': \$ctrl.append,
  'input-append--percentage': \$ctrl.appendPercentage,
  'input-prepend': \$ctrl.prepend
  }">
  <span class="add-on glue-prepended" ng-if="\$ctrl.prepend" ng-bind="\$ctrl.prepend"></span>
  <div class="transclude" ng-transclude></div>
  <span class="add-on glue-appended" ng-if="\$ctrl.append" ng-bind="\$ctrl.append"></span>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/glue-container/glue-container.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;